import React from 'react';

interface MoonIconProps {
  size?: number;
  color?: string;
}

/**
 * MoonIcon Component
 * @description Moon icon representing dark theme mode
 * @param size - Icon size in pixels (default: 24)
 * @param color - Icon color (default: 'currentColor')
 */
export const MoonIcon: React.FC<MoonIconProps> = ({ 
  size = 24, 
  color = 'currentColor' 
}) => {
  return (
    <svg 
      width={size}
      height={size}
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" 
        stroke={color} 
        strokeWidth="2" 
        fill="none" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default MoonIcon;

